import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import {
  ArrowDropDown,
  Badge,
  EditNote,
  EventAvailable,
  Group,
  Home,
  School,
  SentimentDissatisfied,
  Visibility,
  Wc,
} from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import SpaIcon from "@mui/icons-material/Spa";
import TaskIcon from "@mui/icons-material/Task";
import useDebouncedValue from "hooks/useDebouncedValue";
import { Spinner } from "react-bootstrap";
import { Alaap_dev, CMS_maati } from "urlconfig";
import EditProjectFarmer from "./EditProjectFarmer";
import { FarmerLevelTab } from "./FarmerLevelTab";
import DownloadFarmersData from "./DownloadFarmersData";
import { OliveFarmerDetails } from "./OliveFarmerDetails";
import { useTranslation } from "react-i18next";

export const OliveFirstLevelData = ({
  ids,
  filters, 
  labelData,
  language,
}) => {
  const [farmers, setFarmers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const [open, setOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(25);
  const [total, setTotal] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingCsv, setLoadingCsv] = useState(false);

  const debouncedSearch = useDebouncedValue(searchKey);
  const { t, i18n } = useTranslation();

  useEffect(() => {
       const params = new URLSearchParams();
     
       if (filters?.level2?.label) {
      params.append("filters[level_2]", filters?.level2?.label);
    }
    if (filters?.level3?.label) {
      params.append("filters[level_3]", filters?.level3?.label);
    }
    if (filters?.level4?.label) {
      params.append("filters[level_4]", filters?.level4?.label);
    }
     if (debouncedSearch) {
      params.append(
        "filters[$or][0][name_of_respondent][$containsi]",
        debouncedSearch
      );
      // params.append(
      //   "filters[$or][1][mobile_number][$containsi]",
      //   debouncedSearch
      // );
    }
     params.append("pagination[page]", page);
    params.append("pagination[pageSize]", pageSize);
    params.append("sort[0]", "createdAt:desc");
    const url = `${Alaap_dev}/api/alaap-respondent-details?${params.toString()}`;

    setLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        // console.log("farmers", data?.data);
        const uniqueFarmers = Array.from(
          new Map(
            (data?.data ?? []).map((farmer) => [farmer.id, farmer])
          ).values()
        );

        setFarmers(uniqueFarmers);

        setTotal(data?.meta?.pagination?.total || uniqueFarmers.length);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching farmer data:", err);
        setLoading(false);
      });
  }, [debouncedSearch, language,filters,page,
    pageSize,]);

  useEffect(() => {
    setPage(1);
  }, [filters]);

  const handleEditClick = (farmer) => {
    // console.log("farmer888",farmer)
    setSelectedFarmer(farmer);
    setOpen(true);
  };

  const handleEditFarmer = (farmer) => {
    setSelectedFarmer(farmer);
    setEditModal(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFarmer(null);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const getLabel = (key) => {
    const found = labelData?.find((item) => item.key === key);
    return found?.label || key;
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <CircularProgress />
        <Typography variant="subtitle1" mt={2}>
          Loading Farmer Details...
        </Typography>
      </Box>
    );
  }

  const DetailRow = ({ icon: Icon, label, value, color }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        backgroundColor: "#fafafa",
        "&:hover": { backgroundColor: "#f5f5f5" },
        transition: "0.2s",
        flex: 1,
        minWidth: 220,
      }}
    >
      <Box
        sx={{
          background: color.bg,
          color: color.text,
          borderRadius: "50%",
          width: 32,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon fontSize="small" />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: "text.secondary", lineHeight: 1.2 }}
        >
          {label}
        </Typography>

        {Array.isArray(value) ? (
          <Box sx={{ mt: 0.5, display: "flex", flexWrap: "wrap", gap: 1 }}>
            {[...new Set(value.map((v) => String(v)))]
              .sort((a, b) => a?.localeCompare(b))
              .map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.3,
                  }}
                >
                  <Checkbox
                    checked
                    sx={{
                      p: 0,
                      width: 16,
                      height: 16,
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                      },
                      color: color.text,
                      "&.Mui-checked": { color: "green" },
                    }}
                  />

                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, marginTop: 0.1 }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
          </Box>
        ) : (
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.3 }}>
            {value || "N/A"}
          </Typography>
        )}
      </Box>
    </Box>
  );

  const handleChangeSearch = (message) => {
    setPage(1);
    setSearchKey(message);
  };
  return (
    <Box sx={{ p: 3 }}>
      <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between mt-3 mb-3">
        <TextField
          size="small"
          placeholder={t("Search by Name")}
          value={searchKey}
          onChange={(e) => handleChangeSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchKey && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => handleChangeSearch("")}
                  edge="end"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            minWidth: 300,
            "& .MuiInputBase-input": {
              fontSize: 14,
              padding: "9px 2px",
            },
          }}
        />

        <h5 className=" text-center mb-2">👨‍🌾 {t("Farmer Level Data")}</h5>
      </div>

      <Grid container spacing={2}>
        {farmers?.length > 0 ? (
          farmers?.map((farmer) => (
            <Grid item xs={12} key={farmer?.id}>
              <Card
                sx={{
                  borderRadius: "14px",
                  overflow: "hidden",
                  transition: "0.3s",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                <Box
                  sx={{
                    color: "black",
                    p: 2,
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    gap: { xs: 1, sm: 2 },
                    position: "relative",
                    borderBottom: "1px solid #eee",
                    boxShadow: "inset 0 -2px 0 #f0f0f0",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 46,
                        height: 46,
                        background: "linear-gradient(135deg, #ffecb3, #ffcc80)",
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 26 }} />
                    </Avatar>

                    <Box>
                      <Typography variant="subtitle1" fontWeight={700} noWrap>
                        {farmer?.name_of_respondent}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          opacity: 0.75,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          flexWrap: "wrap",
                        }}
                      >
                        <span className="text-black">{t("Onboarding Date")}:</span>{" "}
                        {farmer?.createdAt?.slice(0, 10)}
                      </Typography>
                    </Box>
                  </Box>

                  <div className="d-flex">
                    <IconButton onClick={() => handleEditClick(farmer)}>
                      <Visibility fontSize="small" sx={{ color: "#ff9800" }} />
                    </IconButton>
                    {/* <IconButton onClick={() => handleEditFarmer(farmer)}>
                      <EditNote fontSize="small" sx={{ color: "#ff9800" }} />
                    </IconButton> */}
                  </div>
                </Box>

                <CardContent sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                        <DetailRow
                          icon={Wc}
                          label={getLabel("gender")}
                          value={`${farmer?.gender}`}
                          color={{ bg: "#FCE4EC", text: "#D81B60" }}
                        />
                        {/* <DetailRow
                          icon={LocationOnIcon}
                          label={getLabel("level_1")}

                          value={farmer?.level_1}
                          color={{ bg: "#FFCDD2", text: "#B71C1C" }}
                        /> */}

                        <DetailRow
                          icon={LocationOnIcon}
                          label={getLabel("level_2")}
                          value={`${farmer?.level_2}`}
                          color={{ bg: "#EDE7F6", text: "#5E35B1" }}
                        />
                        <DetailRow
                          icon={LocationOnIcon}
                          label={getLabel("level_3")}
                          value={farmer?.level_3}
                          color={{ bg: "#E8EAF6", text: "#283593" }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                        {/* <DetailRow
                          icon={LocationOnIcon}
                         label={getLabel("label_4")}
                          value={farmer?.label_4}
                          color={{ bg: "#FFE8E0", text: "#E65100" }}
                        /> */}
                        <DetailRow
                          icon={SpaIcon}
                          label={getLabel(
                            "primary_type_of_agriculture_operation"
                          )}
                          value={farmer?.primary_type_of_agriculture_operation}
                          color={{ bg: "#E8F5E9", text: "#2E7D32" }}
                        />
                        <DetailRow
                          icon={Badge}
                          label={getLabel("total_landholding_in_hectares")}
                          value={farmer?.total_landholding_in_hectares}
                          color={{ bg: "#FFF3E0", text: "#EF6C00" }}
                        />
                        <DetailRow
                          icon={SpaIcon}
                          label={getLabel("years_involved_in_farming")}
                          value={farmer?.years_involved_in_farming}
                          color={{ bg: "#F1F8E9", text: "#558B2F" }}
                        />
                      </Box>
                    </Grid>
                    {/* <Grid
                      item
                      xs={farmer?.completed_forms_list?.length ? 12 : 6}
                    >
                      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                        <DetailRow
                          icon={Home}
label={getLabel("mobile_number")}
                          value={`${farmer?.district}, ${farmer?.block}, ${
                            farmer?.grampanchayat
                          } ,${farmer?.address || ""} `}
                          color={{ bg: "#E3F2FD", text: "#1565C0" }}
                        />
                        {farmer?.completed_forms_list?.length && (
                          <DetailRow
                            icon={TaskIcon}
label={getLabel("mobile_number")}
                            value={farmer?.completed_forms_list}
                            color={{ bg: "#F3E5F5", text: "#7B1FA2" }}
                          />
                        )}
                      </Box>
                    </Grid> */}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <SentimentDissatisfied sx={{ fontSize: 48, color: "#ff9800" }} />
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{ color: "text.secondary" }}
              >
                No Data Found
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                Looks like there are no farmer records available yet.
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>

      {farmers.length > 0 && total > 0 && (
        <Box
          sx={{
            mt: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Page {page} of {Math.ceil(total / pageSize)} • Total {total} Farmers
          </Typography>

          {total > pageSize && (
            <Pagination
              count={Math.ceil(total / pageSize)}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
            />
          )}
        </Box>
      )} 

      {/* <Dialog
        open={editModal}
        onClose={() => setEditModal(false)}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle style={{ background: "#D3D3D36b" }} className="h4">
          Edit Farmer
        </DialogTitle>
        <DialogContent dividers>
          <EditProjectFarmer
            farmer={selectedFarmer}
            documentId={selectedFarmer?.documentId}
            onClose={() => setEditModal(false)}
            page={page}
            pageSize={pageSize}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditModal(false)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog> */}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle className="h4">Details</DialogTitle>
        <DialogContent dividers>
          <OliveFarmerDetails
           labelData={labelData}
           selectedFarmer={selectedFarmer}
           language={language}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
